/**
 * module: dataWilayah
 * berisi data, mutation, getter untuk data propinsi dan kotaKab
 */

import Vuex from 'vuex'

export default {
	namespaced: true,

	state: () => ({
		propinsi: null,
		// kotaKab: null
	}),

	mutations: {
		setPropinsi(state, payload) {
			state.propinsi = payload
		},

		/* setKotaKab(state, payload) {
			state.kotaKab = payload
		} */
	},

	getters: {
		propinsi: (state, getters, rootState) => {
			return state.propinsi
		},

		/* kotaKab: (state, getters, rootState) => {
			return state.kotaKab
		} */
	}
}



// WEBPACK FOOTER //
// ./src/store/dataWilayah.js